<template>
  <div class='header_search'>
    <div class="heading_group">
      <div class="flex">
        <!--        <span @click="testCD">进入禅道test</span>-->
        <div class="heading_group_welcome">您好，欢迎来到游选！</div>
        <div class="heading_group_btn">
          <router-link tag="div" :to="{name:'PersonalCenter'}" class="registerLogin"
                       v-if="this.$store.state.loginStatus">
            <span class="user_center">个人中心 <span id="message"
                                                 v-show="this.$store.state.message + this.$store.state.unReadMessage + this.$store.state.siteNoticeMsg>0">{{
                this.$store.state.message + this.$store.state.unReadMessage + this.$store.state.siteNoticeMsg > 100 ? '99+' : this.$store.state.message + this.$store.state.unReadMessage + this.$store.state.siteNoticeMsg
              }}</span>&emsp;｜&emsp;</span>
            <div class="head_portrait">
              <!--            <img src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng60a5d6456ddef79d8278c812b71d1067121131f9f768480e2bf992543d7b60a7"/>-->
              <img v-if="this.$store.state.userData.touxiang !== ''"
                   :src="this.$store.state.userData.touxiang"
                   @error="$event.target.src = require('@/assets/logo/logo.svg');$event.target.classList.add('default_avatar')"/>
              <img v-else class="default_avatar" src="@/assets/logo/logo.svg"/>
            </div>
            <span class="user_account">&emsp;{{ this.$store.state.userData.nickname }}</span>
          </router-link>
          <router-link tag="a" href="javascript:;" v-else class="register" :to="{name:'Login'}">登录</router-link>
          <a v-if="this.$store.state.loginStatus" href="javascript:;" class="quit" @click="logout">退出</a>
        </div>
      </div>

    </div>
    <div class="header_logo_search">
      <div class="flex">
        <router-link tag="div" class="logo_search" :to="{path:'/'}">
          <img src="@/assets/logo/logo_horizontal_white.svg" alt="游选">
        </router-link>
        <div class="search">
          <div class="search_input">
            <el-select :popper-append-to-body="false" v-model="value" placeholder="" @change="selectChange">
              <el-option v-for="(item,index) in options" :key="index" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
            <input type="text" id="search_input" v-model.trim="searchText" @keyup.enter="searchSubmit"
                   placeholder="请输入关键词进行搜索" @keydown="inputKeyDown" @focus="showRecommend=true" :maxlength='20'
                   @blur="showRecommend=false;recommendIndex=-1" @input="handleInput" autocomplete="off"
                   @compositionstart="flag = false" @compositionend="flag = true">
            <div class="search_recommend" v-show="showRecommend  && (searchText?recommendList.length>0:recommendHistory.length>0)">
              <div class="item" :class="{'active':index === recommendIndex}" v-for="(item,index) in searchText?recommendList:recommendHistory"
                   :key="index" @mousedown="clickRecommend(item)">
                <span>{{ item.title }}</span>
                <span class="itemTip" v-if="!searchText">历史搜索</span>
              </div>
              <div class="historyDel"  v-if="!searchText">
                <span class="itemTip" @mousedown.prevent="recommendHistory = []">全部删除</span>
              </div>
            </div>
            <div class="search_btn" @click="searchSubmit">
              <i class="el-icon-search"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab_bar">
      <el-menu class="el-menu" mode="horizontal" @select="handleSelect" router :default-active="defaultActive">
        <el-menu-item index="/" @click="PCButtonClick('网站首页','')">网站首页</el-menu-item>
        <el-menu-item index="/allGame" @click="PCButtonClick('全部游戏','')">全部游戏</el-menu-item>
        <el-submenu index="accountTrade" popper-class="head_menu_horizontal">
          <template slot="title">账号交易</template>
          <el-menu-item index="/accountTrade/allGame" @click="PCButtonClick('账号交易','我要买号')">我要买号</el-menu-item>
          <el-menu-item index="/accountSell" @click="PCButtonClick('账号交易','我要卖号')">我要卖号</el-menu-item>
          <el-menu-item index="/accRecycle" @click="PCButtonClick('账号交易','账号回收')">账号回收</el-menu-item>
        </el-submenu>
        <el-menu-item index="/vouch" @click="PCButtonClick('担保中介','')">担保中介</el-menu-item>
        <el-submenu index="/tradeTip" popper-class="head_menu_horizontal">
          <template slot="title">交易必看</template>
          <el-menu-item
            @click="PCButtonClick('交易必看',item.page_name)"
            index="/tradeTip" v-for="(item,index) in tradeTip" :key="index"
            :route="'_child' in item ?{name:'TradeTip',query:{id:item._child[0].id,parent_id:item.parent_id}}:{name:'TradeTip',query:{id:item.id,parent_id:item.parent_id}}">
            {{ item.page_name }}
          </el-menu-item>
        </el-submenu>
        <!--        <el-menu-item index="/personalCenter/myAccount">个人中心</el-menu-item>-->
        <el-submenu index="/legal" popper-class="head_menu_horizontal">
          <template slot="title">交易保障</template>
          <el-menu-item
            @click="PCButtonClick('交易保障',item.page_name)"
            index="/legal" v-for="(item,index) in legal" :key="index"
            :route="'_child' in item ?{name:'Legal',query:{id:item._child[0].id,parent_id:item.parent_id}}:{name:'Legal',query:{id:item.id,parent_id:item.parent_id}}">
            {{ item.page_name }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/helpCenter" @click="PCButtonClick('帮助中心','')">帮助中心</el-menu-item>
        <el-submenu index="/about" popper-class="head_menu_horizontal">
          <template slot="title">关于我们</template>
          <el-menu-item
            class="contactUs"
            @click="PCButtonClick('关于我们','联系我们')">
            联系我们
          </el-menu-item>
          <el-menu-item
            @click="PCButtonClick('关于我们',item.page_name)"
            index="/about" v-for="(item,index) in about" :key="index"
            :route="'_child' in item ?{name:'About',query:{id:item._child[0].id,parent_id:item.parent_id}}:{name:'About',query:{id:item.id,parent_id:item.parent_id}}">
            {{ item.page_name }}
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <el-dialog
      :visible.sync="ICDialogVisible"
      custom-class="invitationCodeDia"
      :show-close="false"
      top="35vh"
      center>
        <span>
          <div id="IC_main">
            <div class="IC_title">提示</div>
            <div class="IC_input">
              {{inviteUserInfo.content}}
            </div>
            <div class="IC_btn">
              <div @click="ICDialogVisible = false">取消</div>
              <div @click="roomJoin(inviteUserInfo.roomid)">确认</div>
            </div>
          </div>
          <img class="IC_close" src="@/assets/image/AccountDeal/close.png" alt="" @click="ICDialogVisible = false">
        </span>
    </el-dialog>
  </div>
</template>
<script>
import {apiGameList, apiLogout, apiPSearchList, apiNavPage, apiTopNav, searchParticiple} from '@/request/API'
import chatApi from '@/request/customer/customerRoom'
import {Decrypt} from '@/request/customer/util.js'
import { IMDisconnect } from '../util/im'

export default {
  name: '',
  props: {
  },
  components: {

  },
  data () {
    return {
      activeIndex: '1',
      loginStatus: this.$store.state.loginStatus,
      //搜索
      searchText: '',
      options: [],
      //每日成交下拉框选中
      value: '',
      tradeTip: [],
      about: [],
      legal: [],
      //搜索推荐
      recommendList: [],
      recommendIndex: -1,
      showRecommend: false,
      setTimeOut: null,
      flag: true,
      recommendHistory:[],
      // 邀请加入群聊弹窗
      ICDialogVisible: false,
      inviteUserInfo: {
        content: '',
        roomid: ''
      },
    }
  },

  methods: {
    /**
     * @description: 进入群聊
     * @param {*} id 房间id
     * @return {*}
     */
    roomJoin(id) {
      let routeUrl = this.$router.resolve({
        name: 'chatRoom',
        query: {
          room_id: id,
        }
      });
      this.ICDialogVisible = false
      window.open(routeUrl.href, '_blank');
    },
    initImsSocket() {
      this.$WSIM.on('chat',(e) => {
        let value = e.data
        if(value.msgtype == 15){
          let con = JSON.parse(value.content)
          // let users = con.userid.split(',');
          let cust = con.content.split('创建');
          if(con.userid.indexOf(this.$store.state.userData.telphone)!=-1){
            value.content = cust[0]
            this.inviteUser(value)
          }
        }
        if(value.msgtype == 16){
          let con = JSON.parse(value.content)
          // let users = con.userid.split(',');
          let cust = con.content.split('邀请');
          if(con.userid.indexOf(this.$store.state.userData.telphone)!=-1){
            value.content = cust[0]
            this.inviteUser(value)
          }
        }
      })
    },
    /**
     * @description: 邀请进入群聊
     * @return {*}
     */
    inviteUser(v) {
      let qun_title = ''
      chatApi.querymember({
        format: 'json',
        roomid: v.roomid
      }).then(res =>{
        let res_data = JSON.parse(Decrypt(res.msg))
        if(res_data.type == 3){
          // 群聊
          qun_title = res_data.title
          this.inviteUserInfo.content = v.content+'已经邀您进入群聊【'+qun_title+'】，是否直接开始对话？'
          this.inviteUserInfo.roomid = v.roomid
          this.ICDialogVisible = true
        }
      })
    },
    /*    testCD(){
          let url = 'http://project.pxb7.com/api.php?'
          let code = 'pxb7'
          let key = 'lx8s7vavq8ms85p3ud7gu14n4thuazi4'
          let time = (new Date().getTime() / 1000).toFixed(0)
          let token = this.$md5(code + key + time)
          let newUrl = `${url}m=user&f=apilogin&account=admin&code=${code}&time=${time}&token=${token}`
          window.open(newUrl,'_blank')
        },*/
    searchInputBlur(){
      this.showRecommend=false
      this.recommendIndex=-1
    },
    handleSelect(key, keyPath) {
    },
    //退出
    logout() {
       //  推广连接需求用户退出后仍能使用channel_code
      let channel_code = sessionStorage.getItem('channel_code')

      if (this.$store.state.loginStatus) {
        apiLogout({
          refresh_token:localStorage.getItem('refresh_token')||''
        }).then(res => {
          IMDisconnect()
          this.$message({
            center: true,
            type: 'success',
            message: "退出成功"
          })
          this.$router.replace('/')
        }).catch(err => {
          this.$message({
            center: true,
            type: 'error',
            message: err.msg
          })
        })
      }
      this.$store.commit('del_token')
      this.$store.state.userData = {}
      this.$store.state.loginStatus = false
      sessionStorage.clear();
       //  推广连接需求用户退出后仍能使用channel_code
      if(channel_code) {
        sessionStorage.setItem('channel_code',channel_code)
      }
    },
    //搜索
    searchSubmit() {
      this.$sensorsTrack.GameSearchClick(this.$route.name)
      console.log(this.$route);
      let historyItem = {game_id: 0, keyword: this.searchText, title: this.searchText}
      if (this.recommendHistory.findIndex(v => v.title === historyItem.title) === -1) {
        this.recommendHistory.unshift(historyItem)
        if (this.recommendHistory.length > 10) {
          this.recommendHistory =  this.recommendHistory.slice(0,9)
        }
      }
      this.showRecommend = false
      document.getElementById('search_input').blur()
      apiPSearchList({
        game_id: this.value,
        matchCon: this.searchText
      }).then(res => {
        if(res.data.search_kouling){
          this.$router.push({
            path: 'channel',
            query: {
              coupon_channel:res.data.coupon_channel,
             id:res.data.coupon_id
            },
          })
        }else{
          if (res.data.game.game_id) {
          this.$router.push({
            name: 'SelectGame',
            query: {
              game_id: res.data.game.game_id,
              rec: 's',
              matchCon: res.data.post_key ? this.searchText : ''
            },
            params: {
              game_name: res.data.game.game_name,
              game_class: res.data.game.game_class,
              game_id: res.data.game.game_id,
            }
          })
          this.value = res.data.game.game_id
          }else{
            this.$router.push({
              name: 'SelectGameEmpty',
              query: {
                matchCon: res.data.post_key ? this.searchText : ''
              },
            })
          }
        }
      }).catch(err => {
        this.$message({
          type: "error",
          center: true,
          message: err.msg
        })
      })
    },
    //点击推荐结果
    clickRecommend(item) {
      if (item.game_id == '0') {
        this.value = ''
      }else{
        this.value = item.game_id * 1
      }
      this.searchText = item.keyword
      if (this.recommendHistory.findIndex(v => v.title === item.title) === -1) {
        this.recommendHistory.unshift(item)
        if (this.recommendHistory.length > 10) {
          this.recommendHistory =  this.recommendHistory.slice(0,9)
        }
      }
      this.searchSubmit()
    },
    //监听按键
    inputKeyDown(e) {
      if (e.code === 'ArrowDown') {
        if (this.recommendIndex === this.recommendList.length - 1) {
          this.recommendIndex = 0
        } else {
          this.recommendIndex++
        }
        this.searchText = this.recommendList[this.recommendIndex].keyword
      } else if (e.code === 'ArrowUp') {
        if (this.recommendIndex === 0) {
          this.recommendIndex = this.recommendList.length - 1
        } else {
          this.recommendIndex--
        }
        this.searchText = this.recommendList[this.recommendIndex].keyword
      }
    },
    //输入文本时获取推荐结果
    handleInput() {

      setTimeout(() => {
        if (this.flag) {
          if (this.setTimeOut) {
            clearTimeout(this.setTimeOut)
          }
          if (this.searchText === '') {
            this.recommendList = []
            return
          }
          this.setTimeOut = setTimeout(() => {
            searchParticiple({
              game_id:this.value,
              match: this.searchText
            }).then(res => {
              this.recommendList = res.data
            })
          }, 100)
        }
      }, 0)
    },
    //下拉框监听
    selectChange(event) {
    },
    //获取下拉框数据
    getSelectGame() {
      apiGameList({}).then(res => {
        res.data.forEach((item, index) => {
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.options.push(options)
        })
        let opiton = new Object()
        opiton.value = ''
        opiton.label = '全部游戏'
        this.options.unshift(opiton)
      })
    },
    //导航栏菜单
    getTopNav() {
      apiTopNav({}).then(res => {
        res.data.forEach((item, index) => {
          switch (item.id) {
            case 13:
              this.legal = res.data[index]._child
              break;
            case 83:
              this.tradeTip = res.data[index]._child
              break;
            case 18:
              this.about = res.data[index]._child
              break;
          }
        })
      })
    },

    /**
     * 神策埋点
     * @param first_button
     * @param second_button
     * @constructor
     */
    PCButtonClick(first_button,second_button){
      this.$sensorsTrack.PCButtonClick(first_button,second_button)
      if (second_button == '联系我们') this.contactUsClick()
    },
    /**
     * 联系我们
     */
    contactUsClick(){
      this.$emit('contactUs')
    }

  },
  mounted() {
    //获取下拉框数据
    this.getSelectGame()
    //获取顶部导航栏数据
    this.getTopNav()
    // this.initImsSocket()
  },
  created() {
    this.recommendHistory = localStorage.getItem('recommendHistory')?JSON.parse(localStorage.getItem('recommendHistory')):[]
  },
  watch: {
    $route(to,from) {
      if (to.name != 'SelectGame') {
        this.value = ''
        this.searchText = ''
      }
      // if(from.path == '/chat/list'||from.path == '/chatRoom'){
      //   this.initImsSocket()
      // }
    },
    recommendHistory(val){
      localStorage.setItem('recommendHistory',JSON.stringify(val))
    }
  },
  computed: {
    defaultActive() {
      if (this.$route.path.indexOf('personalCenter') > -1) {
        return '/personalCenter/myAccount'
      }
      if (this.$route.path.indexOf('home') > -1) {
        return '/'
      }
      if (this.$route.path.indexOf('allGame') > -1 || this.$route.path.indexOf('selectgame') > -1 || this.$route.path.indexOf('gamedetails') > -1) {
        return '/allGame'
      }
      return this.$route.path;
    }
  },
}
</script>

<style lang="less">
.head_menu_horizontal {
  .el-menu {
    .refreshRoute{
      color: inherit;
    }
    margin: 0 !important;
    padding: 8px 0 !important;
    // min-width: 171.42px !important;
    min-width: 147.17px !important;
    border: 1px solid var(--border-soft);
    border-radius: 0 0 4px 4px;
    box-shadow: var(--shadow-card);

    .el-menu-item {
      // width: 171.42px;
      width: 147.17px;
      text-align: center;
      height: 42px !important;
      line-height: 42px !important;
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary) !important;
    }

    .el-menu-item:last-of-type {
      border-radius: 0 0 4px 4px;
    }

    .el-menu-item:hover {
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: var(--primary) !important;
      background: var(--bg-tag);
    }

  }
}
</style>

<style lang='less' scoped>
.header_search {
  width: 100vw;
  background: var(--bg-card);

  .heading_group {
    height: 40px;
    border-bottom: 1px solid #1f242c;
    background: var(--bg-stage);
    display: flex;
    width: 100vw;
    align-items: center;
    flex-direction: column;

    .flex {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 40px;

      .heading_group_welcome {
        font-size: 14px;
        color: var(--text-muted);
        float: left;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        padding-left: 2px;

        a {
          font-size: 14px;
          color: var(--text-muted);
          float: left;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          margin: 0 20px 0 0;
          transition: color .2s ease;
        }

        a:hover {
          color: var(--primary);
        }
      }

      .heading_group_btn {
        display: flex;

        a {
          padding: 0;
          margin: 0;
        }

        .register {
          font-size: 14px;
          color: #c7ccd6 !important;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          outline: none;
          transition: color .2s ease;
        }

        .register:hover {
          color: var(--primary) !important;
        }

        .registerLogin {
          font-size: 14px;
          color: #c7ccd6 !important;
          font-family: PingFangSC-Regular, PingFang SC;
          height: 40px;
          display: flex;
          align-items: center;
          cursor: pointer;
          gap: 0 5px;

          .user_center {
            display: inline-block;
            position: relative;

            #message {
              //min-width: 17px;
              height: 17px;
              line-height: 17px;
              background: var(--hot);
              border-radius: 3px;
              font-size: 12px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              padding: 0 5px;
              position: absolute;
              top: 7px;
              right: 40px;
            }
          }

          .head_portrait {
            width: 26px;
            height: 26px;
            display: inline-block;

            img {
              border-radius: 50%;
              height: 100%;
              width: 100%;
              object-fit: cover;
            }

            .default_avatar {
              padding: 4px;
              object-fit: contain;
              box-sizing: border-box;
              background: var(--brand-blue-light);
            }
          }

          .user_account {
            display: inline-block;
            font-family: PingFangSC-Light, PingFang SC;
          }
        }

        .quit {
          margin: 0 0 0 50px;
          font-size: 14px;
          color: #c7ccd6 !important;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          transition: color .2s ease;
        }

        .quit:hover {
          color: var(--primary) !important;
        }

        .appDownload {
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--primary);
          line-height: 22px;

          .hotApp {
            width: 40px;
            height: 18px;
            margin: 0 5px 0 0;
          }

          span {
            font-size: 14px;
            color: var(--text-secondary) !important;
            font-family: PingFangSC-Regular, PingFang SC;
            cursor: default;
          }
        }
      }
    }
  }

  .header_logo_search {
    display: flex;
    width: 100vw;
    align-items: center;
    flex-direction: column;
    background: var(--bg-dark);

    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo_search {
        float: left;
        width: 220px;
        height: 78px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;

        img {
          margin: 1px 0 0 0;
          width: 100%;
          height: 58px;
          object-fit: contain;
          object-position: left center;
        }
      }

      .search {
        float: right;
        width: 424px;
        height: 78px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;

        .search_input {
          position: relative;
          width: 420px;
          height: 42px;
          background: #FFFFFF;
          border-radius: 3px;
          border: 2px solid var(--primary);
          display: flex;
          flex-direction: row;
          align-items: center;

          /deep/ .el-input__inner {
            height: 42px;
            line-height: 42px;
            padding: 0;
            text-align: center;
            width: 116px;
            border-radius: 3px;
            border: none;
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            color: var(--text-main);
          }

          /deep/ .el-input__inner::-webkit-input-placeholder {
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: var(--text-muted);
          }

          /deep/ .el-select__caret {
            color: var(--brand-blue) !important;
            font-size: 12px
          }

          /deep/ .el-select-dropdown__item.hover {
            background-color: var(--brand-blue-light) !important;
          }

          /deep/ .selected {
            color: var(--brand-blue);
          }

          #search_input {
            padding: 0 0 0 10px !important;
            width: 248px;
            padding: 0;
            height: 42px;
            border: none;
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: var(--text-main);
          }

          #search_input::-webkit-input-placeholder {
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: var(--text-muted);
          }

          .search_recommend {
            padding-top: 8px;
            padding-bottom: 16px;
            position: absolute;
            top: 48px;
            left: 116px;
            z-index: 999;
            width: 304px;
            max-height: 40vh;
            background: var(--bg-card);
            border: 1px solid var(--border-soft);
            border-radius: 4px;
            box-shadow: var(--shadow-card);
            overflow-y: auto;

            .item {
              line-height: 20px;
              padding: 8px 18px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary);
              cursor: pointer;
              display: flex;
              justify-content: space-between;
              .itemTip{
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: var(--text-muted);
              }

              &:hover {
                background: var(--brand-blue-light);
              }

              &.active {
                background: var(--brand-blue-light);
              }
            }
            .historyDel{
              padding: 0 18px;
              display: flex;
              align-items: center;
              justify-content: right;
              font-size: 12px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-muted);
              span{
                cursor: pointer;
              }
              span:hover{
                color: var(--brand-blue);
              }
            }
          }

          .search_btn {
            width: 34px;
            height: 34px;
            border-radius: 3px;
            background: var(--primary);
            color: #FFFFFF;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background .2s ease;

            &:hover {
              background: var(--primary-hover);
            }

            i {
              font-size: 16px;
              line-height: 1;
            }
          }
        }
      }
    }
  }

  .tab_bar {
    height: 52px;
    box-shadow: 0 8px 22px rgba(26, 29, 36, 0.08);
    display: flex;
    width: 100vw;
    align-items: center;
    flex-direction: column;
    background: var(--bg-dark);
    border-top: 1px solid #262a33;
    /deep/ .el-menu--horizontal {
      border-bottom: none !important;
    }

    .el-menu {
      width: 1200px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background: var(--bg-dark) !important;
      border-bottom: none !important;

      .el-menu-item {
        // width: 171.42px;
        position: relative;
        width: 147.17px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: #c7ccd6;
        background: transparent !important;
        border-bottom: none !important;
        transition: background-color .2s ease, color .2s ease !important;
      }

      .el-menu-item:hover {
        background: #22262f !important;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #FFFFFF;
      }

      /deep/ .el-submenu {
        // width: 171.42px;
        position: relative;
        width: 147.17px;
        height: 52px;
        line-height: 52px;

        .el-submenu__title {
          position: relative;
          height: 52px;
          line-height: 52px;
          text-align: center;
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 300;
          color: #c7ccd6;
          background: transparent !important;
          border-bottom: none !important;
          transition: background-color .2s ease, color .2s ease !important;

          i {
            color: inherit;
          }
        }

        .el-submenu__title:hover {
          background: #22262f !important;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #FFFFFF;
        }
      }

      /* 激活态三件套：橙底 + 左上7px缺角 + 底部3px白能量条 */
      .el-menu-item.is-active {
        border-bottom: none !important;
        background: var(--primary) !important;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 7px;
          height: 7px;
          background: #fff;
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }

        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 3px;
          background: #fff;
          opacity: .85;
        }
      }

      /deep/ .el-submenu.is-active > .el-submenu__title {
        border-bottom: none !important;
        background: var(--primary) !important;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF !important;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 7px;
          height: 7px;
          background: #fff;
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }

        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 3px;
          background: #fff;
          opacity: .85;
        }
      }
    }
  }

  div .flex {
    width: 1200px;
  }
  /deep/ .invitationCodeDia {
    width: 358px;
    // height: 200px;
    background: #FFFFFF;
    border-radius: 4px;
    position: relative;
    overflow: visible;
    box-sizing: border-box;

    .el-dialog__body {
      padding: 20px 35px 29px;
      position: relative;

      #IC_main {
        display: flex;
        flex-direction: column;
        //align-items: center;
        position: relative;

        .IC_title {
          text-align: center;
          margin: 0 0 10px;
          font-size: 20px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 28px;
        }

        .IC_input {
          margin: 0 0 20px;
        }

        .IC_btn {
          text-align: center;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          color: #000000;
          display: flex;
          justify-content: space-between;
          div{
            width: 136px;
            line-height: 36px;
            height: 36px;
            background: #FFDB51;
            border:1px solid #FFDB51;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }

      .IC_close {
        width: 30px;
        height: 30px;
        position: absolute;
        bottom: -40px;
        left: 164px;
        cursor: pointer;
      }
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-input__inner {
      height: 56px;
      background: #F4F4F4;
      border-radius: 4px;
      border: 1px solid #F0F0F0;
      font-size: 18px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
  }
}
</style>
